module.exports = __webpack_public_path__ + "static/assets/adb0adbec18bc8f11b1ad14505c9bd8a.svg";